












import { Vue, Component } from "vue-property-decorator";
import { Routes } from "@/router/routes";

@Component
export default class SessionTimeout extends Vue {
  reload() {
    this.$router.replace({ name: Routes.Home }).then(() => {
      window.location.reload();
    });
  }
}
